<div aria-modal="true" role="dialog" aria-labelledby="modal-title" aria-describedby="modal-description" id="tab-modal">
    <div class="topaz-dialog-header">
        <h1 topazTitle="3" id="modal-title">Announcement</h1>
        <button mat-icon-button mat-dialog-close="cancel" aria-label="t('closeDialog')" id="closeDialog">
            <fa-icon title="close" size="lg" [icon]="icons.faXmark"></fa-icon>
        </button>
    </div>
    <mat-dialog-content role="document" class="tab-dialog-modal-content">
        <div class="dialogTitle">
            <h4 class="card-title"> 
                {{data?.title}}</h4>
        </div>
        <div class="description">
            <p class="card-Description c-707070"> {{data.description}} </p>
        </div>
    </mat-dialog-content>
</div>